// extracted by mini-css-extract-plugin
export var childrenContainer = "_7r-0";
export var virtualScrollArea = "_7r-1";